
import { Vue } from "vue-class-component";

export default class ClockCargo extends Vue {}
